import { APIFactory } from '../../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';
import {
  convertFromTaxCertificationRequestResponseToTaxCertificationRequestData,
  ITaxCertificationRequestData,
  ITaxCertificationRequestResponse,
} from '../../../types/order/title/ITaxCertificationRequest';
import { AxiosError } from 'axios';

export const getTaxCertificationRequestAsync = async (
  orderId: string
): Promise<ITaxCertificationRequestResponse | undefined> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ITaxCertificationRequestResponse>(`/lender/v1/vendor/orders/${orderId}/active_tax_certification_request`)
    .then((response) => convertFromTaxCertificationRequestResponseToTaxCertificationRequestData(response.data))
    .catch((e: AxiosError) => {
      if (e.response && e.response.status === 404) {
        return Promise.resolve(undefined);
      } else {
        return axiosErrorHandler(e);
      }
    });

export const postCreateTaxCertificationRequestAsync = async (orderId: string): Promise<ITaxCertificationRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<ITaxCertificationRequestResponse>(`/timber/api/internal/orders/${orderId}/tax_certifications_requests`)
    .then((response) => convertFromTaxCertificationRequestResponseToTaxCertificationRequestData(response.data))
    .catch(axiosErrorHandler);

export const postCancelTaxCertificationAsync = async (
  taxCertificationRequestId: string
): Promise<ITaxCertificationRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<ITaxCertificationRequestResponse>(
      `/timber/api/internal/tax_certifications_requests/${taxCertificationRequestId}/cancel`
    )
    .then((response) => convertFromTaxCertificationRequestResponseToTaxCertificationRequestData(response.data))
    .catch(axiosErrorHandler);
